__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "edison365-projects";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.8.2", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(6729))))));
			register("@emotion/styled", "11.8.1", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(4524))))));
			register("@mui/material", "5.5.0", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(4975))))));
			register("react-dom", "17.0.2", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(3935))))));
			register("react-i18next", "11.15.6", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(7056))))));
			register("react-redux", "7.2.6", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(372))))));
			register("react-router-dom", "5.3.0", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(3338))))));
			register("react", "17.0.2", () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(7294))))));
			initExternal(1404);
			initExternal(7632);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};